export default __webpack_public_path__ + "static/media/net_core.4889519c.png";